import React, {useState} from 'react'
import {Modal} from 'react-bootstrap'
import InfoCardCandidate from "../../pages/candidate/components/info-card-candidate";
import {ICandidateShort} from "../../types/candidate/ICandidateShort";
import {DownloadPdfCard} from "../download-pdf-card";

type Props = {
  candidate:  ICandidateShort
  vacancyIds: number[]
}

const CandidateCard = (props: Props) => {

  const [show, setShow] = useState(false);
  const { candidate, vacancyIds } = props;

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return <>
    <button onClick={(e) => {
      handleShow()
    }} className={`dropdown-item`}>
      Карточка
    </button>

    <Modal size="xl" show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Карточка {candidate.firstName} {candidate.lastName}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className={'max-h-[550px] overflow-y-auto'}>
          <InfoCardCandidate candidateId={candidate?.id} vacancyId={vacancyIds[0]}/>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <DownloadPdfCard candidateId={candidate?.id} vacancyIds={vacancyIds}/>
      </Modal.Footer>
    </Modal>
  </>
}

export default CandidateCard